import { apiHttpService } from './apiHttpService';
import { Account, User, UserResponse } from '../domains/app';
import { AxiosResponse } from 'axios';

export const fetchListUser = (
  pageSize: number,
  page: number,
  search?: string,
): Promise<UserResponse> => {
  return apiHttpService
    .get(
      `/api/Person?pageSize=${pageSize}&page=${page}${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response: AxiosResponse<UserResponse>) => {
      response.data.items.forEach(
        (it) => (it.fullName = `${it.firstName} ${it.lastName}`),
      );
      return response.data;
    });
};

export const fetchProfile = (): Promise<{ user: User } | { error: any }> => {
  return apiHttpService
    .get(`/api/Person/profile`)
    .then((response) => ({ user: response.data as User }))
    .catch((error) => ({ error }));
};

export const createUser = (user: User): Promise<User> => {
  return apiHttpService
    .post(`/api/Person`, user)
    .then((response) => response.data);
};

export const fetchListAccounts = (): Promise<Account[]> => {
  return apiHttpService
    .get(`/api/Person/profile/account`)
    .then((response) => response.data);
};

export const updateProfile = (user: User): Promise<User> => {
  return apiHttpService
    .put(`api/Person`, user)
    .then((response) => response.data);
};

export const deleteUser = (id: string): Promise<User> => {
  return apiHttpService
    .delete(`api/Person/${id}`)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  fetchListUser,
  fetchProfile,
  createUser,
  fetchListAccounts,
  updateProfile,
  deleteUser,
};
